// extracted by mini-css-extract-plugin
module.exports = {"categories-row--desktop":"_1410bfd27b--categories-row--desktop--q_UC1","categories-col--desktop":"_1410bfd27b--categories-col--desktop--JYXDs"};